import React from 'react';
import {
  Modal,
  Checkbox,
} from 'react-bootstrap';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Button from '../../elements/CustomButton/CustomButton.jsx';
import ModalBlockWrapper from '../Components/ModalBlockWrapper';

export default class ContractModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxState: false,
    };
    this.handleCheckbox = this.handleCheckbox.bind(this);
  }

  handleCheckbox(e) {
    this.setState({ checkboxState: e.target.checked });
  }

  render() {
    return (
      <div>
        <Modal show={true} onHide={this.props.onClose}>
          <ModalBlockWrapper
            content={
              <div>
                <Modal.Header closeButton>
                  <Modal.Title>{this.props.contrato.nombre}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{'maxHeight': 'calc(100vh - 210px)', 'overflowY': 'auto'}}>
                  <Editor
                    toolbarHidden
                    readOnly
                    wrapperClassName="editor-height"
                    localization={{ locale: 'es' }}
                    contentState={JSON.parse(this.props.contrato.contrato)}
                  />
                </Modal.Body>
                <Modal.Footer>
                  <span style={{ float: 'left' }}>
                    <Checkbox inline onClick={(e) => this.handleCheckbox(e)}>
                      Acepto los términos y condiciones
                    </Checkbox>
                  </span>
                  <Button onClick={() => this.props.onContinue(this.props.contrato.idmiembro, this.props.contrato.idcontrato)} disabled={!this.state.checkboxState}>Continuar</Button>
                </Modal.Footer>
              </div>
            }
          />
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ContractModal/ContractModal.jsx